// extracted by mini-css-extract-plugin
module.exports = {"arrow-down__container":"arrow-down__container","arrowDownContainer":"arrow-down__container","arrow-down__body":"arrow-down__body","arrowDownBody":"arrow-down__body"};